import { Box, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ExpensesViewMore = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openMenuId, setOpenMenuId] = useState(null);
  const openDropMenu = Boolean(anchorEl);
  const navigate = useNavigate();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const location = useLocation();
  const rowData = location.state;

  const {
    id,
    created_at,
    title,
    description,
    user_type,
    article,
    file,
    for: forUser,
  } = rowData || {};
  const date = new Date(created_at);

  // Extract the day, month, and year from the Date object
  const day = String(date.getDate()).padStart(2, "0"); // Adds leading zero if necessary
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed, so add 1
  const year = date.getFullYear();

  // Format the date as "DD-MM-YYYY"
  const formattedDate = `${day}-${month}-${year}`;
  const handleOpenMenu = (id) => {
    setOpenMenuId(id);
  };
  const handleClosePage = () => {
    navigate("/knowledge");
  };
  const convertToPlainText = (htmlContent) => {
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(htmlContent, "text/html");
    return parsedHtml.body.textContent || "";
  };
  const convertToUserType = (value) => {
    if (value === "1") return "Client";
    if (value === "2") return "Employee";
    if (value === "3") return "App User";
    return "Unknown"; // Fallback for invalid values
  };
  const convertToMainUserType = (value) => {
    if (value === "1") return "Driver";
    if (value === "2") return "Owner";
    if (value === "3") return "Dhaba";
    if (value === "4") return "Mechanic";
    if (value === "5") return "Crane Owner";
    if (value === "6") return "Crane Operator";

    return "Unknown"; // Fallback for invalid values
  };
  return (
    <Box
      sx={{
        color: "#333",
        padding: "10px",
        fontSize: "20px",
        fontWeight: 550,
      }}
    >
      <Box sx={{ color: "#333", bgcolor: "#fff", height: "auto" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid rgb(187, 186, 186) ",
          }}
        >
          <Box sx={{ padding: "15px" }}>Expenses Details</Box>
        </Box>
        <Box>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Item Name
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                {title}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Category
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                {article}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Price
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                {formattedDate}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Purchase Date
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                {convertToUserType(forUser)}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Purchased From
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                {convertToMainUserType(user_type)}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Project
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                {convertToPlainText(description)}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Bank Account
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                {file ? (
                  <a
                    href={`https://rptpl.roadpilot.co.in/public/${file}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ cursor: "pointer" }}
                  >
                    <em>Pdf</em>
                  </a>
                ) : (
                  "No file available"
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Bill
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                ---
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Employee
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                ---
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Description
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                ---
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Status
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                ---
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4} sx={{ paddingBottom: "15px" }}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Approved By
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                ---
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default ExpensesViewMore;
